export default __webpack_public_path__ + "static/media/dark-roof.6d5e7cab.webp";